import { Link } from "react-router-dom";
import AndrewDilksIcon from "../images/AndrewDilksIcon.png"
import AndrewDilksIconDark from "../images/AndrewDilksIconDark.png"
import { getStyle } from "./helpers";

const mainText = "I've created this website as a way to demonstrate my coding abilities and to grow my understanding of "+
  "open source UI library components that are are fun to work with. " +
  "I'll add some thoughts and other tech related content. As you may be able to tell, this site " +
  "is very much under active development.";

const subHeader = "You have now visited AndrewDilks.com!"

const iconMaxWidth = "35%"

export const lightOrDarkImage = (dark) => {
  var icon = AndrewDilksIcon
  var bgColor = "white"
  var boarderColor = "2px solid black"

  if (dark) {
    icon = AndrewDilksIconDark
    bgColor = "rgba(33, 37, 41, 0.8)"
    boarderColor = "5px solid white"
  }

  return (
    <img src={ icon } alt="logo"
      style={{
        maxWidth: iconMaxWidth,
        border: boarderColor,
        borderRadius: "20px",
        backgroundColor: bgColor,
        float: "right",
        margin: "40px 40px 40px 40px"
      }}
    />
  )
}

const sectionOne = (dark) => (
  <div id="navs2" className="p-4 mb-4" style={ getStyle(dark) } >

    <div className="container-fluid pt-4 pb-5">

      <>
        <div style={{
          float: "left",
          paddingLeft: "10px",
        }}>
          <h1 className={"display-5 fw-bold" + (dark ? " text-white" : "") } >
            { "Welcome" }
          </h1>
        </div>

        <div style={{ paddingLeft: "10px",  }}>
          { lightOrDarkImage(dark) }
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </>


      <h2 className={"display-7" + (dark ? " text-white" : "")} style={{ paddingLeft: "10px", marginBottom: "0" }}>
        { subHeader }
      </h2>
      <br />

      <p className={"col-md-10" + (dark ? " text-white" : "") } style={{ padding: "10px" }}>
        { mainText}
      </p>
      <br />

      <SectionButtons dark={dark} />
    </div>
  </div>
);

const SectionButtons = ({ dark }) => {
  // TODO - imporve
  const buttonStyle = dark 
    ? { marginTop: "1rem" }
    : { marginTop: "1rem" };

  return (
    <center>
      <Link to="/blog" style={{ paddingRight: "1rem" }}>
        <button className="btn btn-light btn-lg" type="button" style={buttonStyle}>
          Read the latest from my Blog
        </button>
      </Link>
      <Link to="/found" style={{ paddingRight: "1rem" }}>
        <button className="btn btn-light btn-lg" type="button" style={buttonStyle}>
          Checkout some Cool websites I've found
        </button>
      </Link>
      <Link to="/games" style={{ paddingRight: "1rem" }}>
        <button className="btn btn-light btn-lg" type="button" style={buttonStyle}>
          Play some games!
        </button>
      </Link>
      <Link to="/comments" style={{ paddingRight: "1rem" }}>
        <button className="btn btn-light btn-lg" type="button" style={buttonStyle}>
          Leave a comment!
        </button>
      </Link>
    </center>
  );
};

const sectionTwo = (
  <div className="col-md-6 p-2">
    <div className="h-100 p-5 text-white" style={getStyle(true)}>
      <h2> Check under the hood </h2>
      <p>
        Create React App, React-Router, github, aws s3, aws route53, 
        namecheap, bootstrap, mui, and xp github css files
      </p>
      <Link to="/changelog">
        <button className="btn btn-outline-light btn-lg" type="button">
          Checkout the Changelog
        </button>
      </Link>
    </div>
  </div>
);

const sectionThreeContent = (
  <>
    <h2> Custom built for ios and Apple devices </h2>
    <p>
      If you have any ideas for fun things to do with websites please let me know. 
      I have a few hackathon project ideas I might be able to use...
    </p>
  </>
)


const sectionThree = (dark) => (
  <div className="col-md-6 p-2">
    <div className={ dark ? "h-100 p-5 text-white" : "h-100 p-5" } style={ getStyle(dark) }>
      { sectionThreeContent }
    </div>
  </div>
);


export const LandingPage = (dark) => {
  return (
    <div>
      <div className="container py-4" style={{ position: "relative" }}>
        { sectionOne(dark) }

        <div className="row align-items-md-stretch">
          { sectionTwo }
          { sectionThree(dark) }
        </div>

        <footer className="pt-3 mt-4 text-muted border-top" />
      </div>
    </div>
)}
